<template>
  <div v-if="profile && profile.id" class="pa-4">
    <div class="py-3">
      <div class="title pb-3">Contact Details</div>
      <MobileNumber :value="profile.mobileNumber" />
    </div>

    <div class="py-3">
      <div class="title pb-3">Personal Details</div>
      <Identification :value="profile" />
      <DateOfBirth :value="profile" />
      <Gender :value="profile.gender" attach />
      <Ethnicity :value="profile.ethnicity" />
      <LanguageProficiencies :value="profile.languages" />
      <WorkRights :value="profile.workRights" attach />
      <Location :value="profile.location" />
      <License :value="profile.driversLicense" />
      <Disability :value="profile" />
    </div>

    <div class="py-3">
      <div class="title pb-3">Achievements</div>
      <Achievements :value="profile.achievements" @refresh="$emit('refresh')" />
    </div>

    <div class="py-3">
      <div class="title pb-3">Skills &amp; Expertise</div>
      <BehavioralCompetencies :value="profile.behavioralCompetencies" />
      <TechnicalCompetencies :value="profile.technicalCompetencies" />
      <ProfessionalTools :value="profile.professionalTools" />
    </div>

    <div class="py-3">
      <div class="title pb-3">Interests, Clubs &amp; Societies</div>
      <Affiliations :value="profile.affiliations" />
      <Interests :value="profile.interests" />
    </div>
  </div>
</template>

<script>
// Components
import Achievements from '@/components/candidate/profile/edit/details/Achievements'
import Affiliations from '@/components/candidate/profile/edit/details/Affiliations'
import BehavioralCompetencies from '@/components/candidate/profile/edit/details/BehavioralCompetencies'
import DateOfBirth from '@/components/candidate/profile/edit/details/DateOfBirth'
import Disability from '@/components/candidate/profile/edit/details/Disability'
import Ethnicity from '@/components/candidate/profile/edit/details/Ethnicity'
import Gender from '@/components/candidate/profile/edit/details/Gender'
import Identification from '@/components/candidate/profile/edit/details/Identification'
import Interests from '@/components/candidate/profile/edit/details/Interests'
import LanguageProficiencies from '@/components/candidate/profile/edit/details/LanguageProficiencies'
import License from '@/components/candidate/profile/edit/details/License'
import Location from '@/components/candidate/profile/edit/details/Location'
import MobileNumber from '@/components/candidate/profile/edit/details/MobileNumber'
import ProfessionalTools from '@/components/candidate/profile/edit/details/ProfessionalTools'
import TechnicalCompetencies from '@/components/candidate/profile/edit/details/TechnicalCompetencies'
import WorkRights from '@/components/candidate/profile/edit/details/WorkRights'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: {
    Achievements,
    Affiliations,
    BehavioralCompetencies,
    DateOfBirth,
    Disability,
    Ethnicity,
    Gender,
    Identification,
    Interests,
    LanguageProficiencies,
    License,
    Location,
    MobileNumber,
    ProfessionalTools,
    TechnicalCompetencies,
    WorkRights,
  },

  props: { profile: { type: Object, required: true } },
}
</script>
